export default "__VITE_ASSET__DFAAIRd2__"